module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-17.7e4ebae4.png";